/**
 * Created by Jerker Nord on 2018-12-21.
 */
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {ThorGameMode} from "../gamemode/ThorGameMode";
import {ThorParsedGameData} from "../server/data/ThorParsedGameData";
import {ThorPromoPanelConfig} from "../ThorPromoPanelConfig";

export class ThorSpinController extends SpinController {

    private _reelsToSpin: boolean[];
    private _isDisabledReels: boolean = false;
    private _scatterPositions: number[];

    constructor() {
        super();
    }

    protected parseGameData(data: ThorParsedGameData): void {

        this._reelsToSpin = [true, true, true, true, true];

        if (data.mode == ThorGameMode.SCATTER_RESPIN || data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            this._isDisabledReels = true;
            this._scatterPositions = <number[]>(data.scatterPositions);
            for (let i: number = 0; i < data.reels.length; i++) {
                for (let j: number = 3; j < 6; j++) {
                    if (data.reels[i][j] == "S" && j < 5) {
                        this._reelsToSpin[i] = false;
                        break;
                    } else {
                        this._reelsToSpin[i] = true;
                    }
                }
            }
        } else if (((data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN)
                || (data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN))
            || (data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)
            || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)) {
            this._reelsToSpin[4] = false;
            this._isDisabledReels = true;
        } else {
            this._isDisabledReels = false;
        }

        if (data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            this._isDisabledReels = true;
        }
    }

    protected getReelsGameConfigFromPreviousGameData(): boolean[] {
        if (this._isDisabledReels == true) {
            return this._reelsToSpin;
        } else {
            return super.getReelsGameConfigFromPreviousGameData();
        }
    }

    protected startSpin() {
        ThorPromoPanelConfig.scatterNearWinFlag = true;
        super.startSpin();
    }
}